import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../lib/cn";

const buttonVariants = cva(
  "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors duration-150 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary: "bg-accent text-accent-fg hover:bg-accent-hover",
        secondary:
          "border border-border-strong bg-bg-raised text-fg hover:bg-bg-overlay",
        ghost: "text-fg-muted hover:bg-bg-overlay hover:text-fg",
        danger: "bg-danger text-accent-fg hover:opacity-90",
        ai: "ai-ring bg-bg-raised text-ai hover:bg-accent-soft",
      },
      size: {
        sm: "h-7 px-2.5 text-xs",
        md: "h-8.5 px-3.5",
        lg: "h-10 px-5",
        icon: "size-8.5",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  },
);

export interface ButtonProps
  extends React.ComponentProps<"button">,
    VariantProps<typeof buttonVariants> {}

export function Button({ className, variant, size, ...props }: ButtonProps) {
  return (
    <button
      data-slot="button"
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { buttonVariants };
